import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { googleAuthenticate } from "../../redux/actions/auth";
import queryString from "query-string";

const Google = ({ googleAuthenticate, isAuthenticated }) => {
  const location = useLocation();
  // Control de redirección y de transición (fade-in)
  const [redirect, setRedirect] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // Activa la animación de opacidad al montar
    setShowLoader(true);

    const values = queryString.parse(location.search);
    const state = values.state || null;
    const code = values.code || null;

    if (state && code) {
      googleAuthenticate(state, code).then(() => {
        // Si quieres darle tiempo a la transición antes de redirigir, usa setTimeout
        // Si no, redirige directamente
        setRedirect(true);
      });
    }
  }, [location, googleAuthenticate]);

  if (isAuthenticated || redirect) {
    return <Navigate to="/" />;
  }

  return (
    <div
      className={`
        flex justify-center items-center min-h-screen bg-gray-100 
        transition-opacity duration-700 
        ${showLoader ? "opacity-100" : "opacity-0"}
      `}
    >
      <div className="flex flex-col items-center">
        {/* SPINNER */}
        <div className="relative w-16 h-16 animate-spin rounded-full border-t-4 border-emerald-600 border-b-4 border-transparent">
          {/* 
            También podrías usar un gradiente en lugar de un borde sólido, 
            por ejemplo:
            className="relative w-16 h-16 animate-spin rounded-full
                       bg-gradient-to-r from-emerald-600 via-blue-500 to-purple-600"
            luego un pseudo-elemento para el “centro blanco”.
          */}
        </div>
        <p className="mt-4 text-gray-700 text-lg font-medium">
          Authenticating with Google...
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps, { googleAuthenticate })(Google);
